import * as React from "react";
import { connect } from "react-redux";
import * as router from "react-router-redux";

import _isNil from "lodash/isNil";

import { LOADING_STATES } from "../modules/user/constants";
import * as tokens from "../modules/user/actions";
import * as session from "../modules/session/actions";
import * as userUtils from "../modules/user/utils";
import EmailAndPasswordForm from "../components/EmailAndPasswordForm";

class AcceptInvitationContainer extends React.PureComponent {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentWillMount() {
        this.fetchUserInvitationTokenIfAbsent(this.props);
    }

    componentWillReceiveProps(nextProps) {
        this.fetchUserInvitationTokenIfAbsent(nextProps);
    }

    fetchUserInvitationTokenIfAbsent(props) {
        if (props.loadingStatus === LOADING_STATES.absent) {
            return props
                .fetchUserInvitationToken(props.tokenId)
                .catch(err => this.props.navigateTo("/login"));
        }
    }

    handleSubmit({ password, remember }) {
        this.props
            .acceptUserInvitation(
                this.props.token.token,
                this.props.user.emailAddress,
                password
            )
            .then(result =>
                this.props.userAuthorizationSuccess(result.authData)
            )
            .then(authResult => {
                // Auth errors are returned by userAuthorizationSuccess, not thrown. That's why they get handled here
                // instead of the .catch below.
                if (_isNil(authResult.errorMessage)) {
                    // If the userAuthorizationSuccess action resolves successfully, then we have a valid user session.
                    // I redirect to "/" and let the app decide where to go from there.
                    return this.props.navigateTo("/");
                }
            })
            .catch(err => {
                // Hmm...  the acceptUserInvitation action handles HTTP errors but re-throws the exception. I don't
                // think that's factored properly. It should be possible to override error handling.
                console.error(err);
            });
    }

    render() {
        const isLoading =
            this.props.loadingStatus === LOADING_STATES.absent ||
            this.props.loadingStatus === LOADING_STATES.loading;
        const headerText = this.props.user
            ? `Hello ${this.props.user.firstName}!`
            : "Searching for your invitation...";
        return (
            <main>
                <EmailAndPasswordForm
                    formHeader={headerText}
                    instructionText="Create your password to get started."
                    emailAddress={
                        this.props.user && this.props.user.emailAddress
                    }
                    emailEditable={false}
                    passwordPlaceholder="Create Password"
                    passwordValidator={userUtils.isValidPassword}
                    isLoading={isLoading}
                    onSubmit={this.handleSubmit}
                />
            </main>
        );
    }
}

function mapStateToProps(state, ownProps) {
    const tokenId = ownProps.match.params.tokenId;
    const token = state.entities.tokens && state.entities.tokens[tokenId];
    const user = token ? state.entities.users[token.user] : null;
    const loadingInfo = state.user.tokens[tokenId] || {
        status: LOADING_STATES.absent
    };
    const props = {
        tokenId,
        token,
        user,
        loadingStatus: loadingInfo.status,
        loadingError: loadingInfo.error
    };
    return props;
}

function mapDispatchToProps(dispatch) {
    return {
        fetchUserInvitationToken: tokenId =>
            dispatch(tokens.fetchUserInvitationToken(tokenId)),
        acceptUserInvitation: (tokenId, email, password) =>
            dispatch(tokens.acceptUserInvitation(tokenId, email, password)),
        navigateTo: url => dispatch(router.push(url)),
        userAuthorizationSuccess: data =>
            dispatch(session.userAuthorizationSuccess(data))
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AcceptInvitationContainer);



// WEBPACK FOOTER //
// ./src/containers/AcceptInvitationContainer.js